import { render, staticRenderFns } from "./FeaturedTerrainsSection.vue?vue&type=template&id=e9491e68&scoped=true&"
import script from "./FeaturedTerrainsSection.vue?vue&type=script&lang=js&"
export * from "./FeaturedTerrainsSection.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedTerrainsSection.vue?vue&type=style&index=0&id=e9491e68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9491e68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
